import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import theme from './theme/theme';
import { PersistGate } from 'redux-persist/integration/react';
import { getMissingFirebaseWebEnvKeys } from './firebase/config';
import { bootstrapMenuManagementRemoteConfig } from './firebase/bootstrapMenuManagementRemoteConfig';

const firebaseDebug =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_FIREBASE_DEBUG === 'true';

if (firebaseDebug) {
  const missing = getMissingFirebaseWebEnvKeys();
  if (missing.length > 0) {
    // eslint-disable-next-line no-console
    console.warn('[Firebase] Missing environment variables:', missing);
  } else {
    // eslint-disable-next-line no-console
    console.info(
      '[Firebase] Web config env vars are set. projectId:',
      process.env.REACT_APP_FIREBASE_PROJECT_ID,
    );
  }
}

bootstrapMenuManagementRemoteConfig();

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter basename="">
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </PersistGate>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
